module.exports = __webpack_public_path__ + "static/img/justbubly_th.f6e4ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/justbubly_th.png
// module id = 9NZi
// module chunks = 0